<template>
  <layout
    :menu-is-opened="openMenu"
    @logout="_logout"
    @burger-click="_openLeftMenu"
    :user-data="user"
  >
    <el-container style="position: relative ">
      <left-menu
        v-if="true"
        :menu-list="menuList"
        :open-menu="openMenu"
        @close-menu="_closeMenu"
        @menu-item-click="_onMenuItemClick"
      />
      <div
        v-if="false"
        class="regfest-service-menu__overlay"
        :class="{'regfest-service-menu__overlay--active': openMenu}"
        @click="_closeMenu"
      />
      <div
        v-if="false"
        ref="menu"
        class="regfest-service-menu"
        :class="{'regfest-service-menu--mobile-active': openMenu}"
      >
        <div class="regfest-service-menu__container">
          <div class="regfest-service-menu__header">Услуги</div>
          <div class="regfest-service-menu__list">
            <router-link
              v-for="item in menuList"
              :key = item.eventId
              @click.native="_onMenuItemClick"
              :to="{ name: 'participantTable', params: {eventId: item.eventId}}"
              class="regfest-service-menu__list-item"
              tag="div"
            >
              {{ item.name }}
            </router-link>
          </div>
        </div>
      </div>
      <el-main>
        <slider
          :data="dates"
          @slide-click="_onSlideClick"
        />
        <div v-if="!$route.params.serviceId">Выберите услугу для отображения</div>
        <router-view/>
      </el-main>

    </el-container>
  </layout>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import _ from 'lodash';
import Layout from '@/app/components/layout/Layout.vue';
import Slider from '@/app/components/slider/Slider.vue';
import LeftMenu from '@/app/components/leftMenu/LeftMenu';

export default {
  name: 'ServiceIndex',
  components: { LeftMenu, Slider, Layout },
  data() {
    return {
      openMenu: false,
    }
  },
  computed: {
    ...mapGetters('app/settings', [
      'loading',
      'menuList',
      'dates',
      'eventId',
    ]),
    ...mapGetters('app/user', [
      'user'
    ])
  },
  methods: {
    ...mapActions('service/participantsList', [
      'fetchParticipantList'
    ]),
    ...mapActions('app/settings', [
      'fetchServices',
      'fetchEvent',
    ]),
    _onMenuItemClick(id) {
      this._closeMenu();
      this.$router.replace({query: {date: this.$route.params.date || this.dates[0].date}});
      this.fetchParticipantList({eventId: this.eventId, serviceId: this.$route.params.serviceId, date: this.$route.params.date || this.dates[0].date})
      .catch(() => this.$message.error('Ошибка получения данных'))
    },
    _openLeftMenu() {
      this.openMenu = !this.openMenu;
    },
    _onSlideClick(slide) {
      if (!this.$route.params.serviceId && !this.__eventFinder(this.$route.params.serviceId)) {
        this.$message.error({
          message: 'Выберите услугу для отображения расписания',
          duration: 500
        })
        return;
      }
      this.$router.replace({query: {date: slide.date}});
      this.fetchParticipantList({eventId: this.eventId, serviceId: this.$route.params.serviceId, date: this.$route.query.date ?? null})
        .catch(() => this.$message.error('Ошибка получения данных'))
    },
    _logout() {
      this.$accessManager.logout();
    },
    _closeMenu() {
      this.openMenu = false;
    },
    _clickOutOfElementListener(event){
      if (!this.$refs.menu.$el.contains(event.target)) {
        this.openMenu = false;
      }
    },
    __eventFinder(serviceId) {
      return  !!this.menuList.find( menu  => {
        return menu.id === serviceId;
      });
    }
  }
};
</script>
